import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto pt-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3" }
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notifica = _resolveComponent("Notifica")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifiche, (n) => {
          return (_openBlock(), _createBlock(_component_Notifica, {
            key: n.id,
            id: n.id,
            onRead: _ctx.fetchNotification,
            date: _ctx.$filters.toDate(n.created_at),
            testoNotifica: _ctx.getTextNotifica(n),
            "colore-attivo": "bg-white",
            mark_as_read: n.data?.markable,
            to: _ctx.getLinkNotifica(n)
          }, null, 8, ["id", "onRead", "date", "testoNotifica", "mark_as_read", "to"]))
        }), 128))
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "py-4 flex items-center justify-between" }, [
        _createElementVNode("div", { class: "text-3xl font-bold" }, "Il tuo profilo")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            modelValue: _ctx.user_model.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user_model.name) = $event)),
            field_name: "Nome",
            errors: _ctx.getErrors('name')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            field_name: "Giorno di assunzione",
            errors: _ctx.getErrors('giorno_assunzione')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user_model.giorno_assunzione) = $event)),
                type: "date",
                class: "flex-grow p-7px bg-next-gray-md-dark hover:bg-white"
              }, null, 512), [
                [_vModelText, _ctx.user_model.giorno_assunzione]
              ])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, {
            modelValue: _ctx.user_model.telefono,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user_model.telefono) = $event)),
            field_name: "Numero di telefono",
            errors: _ctx.getErrors('telefono')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            modelValue: _ctx.user_model.ruolo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user_model.ruolo) = $event)),
            field_name: "Ruolo",
            errors: _ctx.getErrors('ruolo')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            field_name: "Data di nascita",
            errors: _ctx.getErrors('nascita')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user_model.nascita) = $event)),
                type: "date",
                class: "flex-grow p-7px bg-next-gray-md-dark hover:bg-white"
              }, null, 512), [
                [_vModelText, _ctx.user_model.nascita]
              ])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            modelValue: _ctx.user_model.dipartimento,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user_model.dipartimento) = $event)),
            field_name: "Dipartimento",
            errors: _ctx.getErrors('dipartimento')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            modelValue: _ctx.user_model.contatto_emergenza,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user_model.contatto_emergenza) = $event)),
            field_name: "Contatto di emergenza",
            errors: _ctx.getErrors('contatto_emergenza')
          }, null, 8, ["modelValue", "errors"])
        ])
      ])
    ])
  ]))
}